import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../enums';
import menuHours from './components/menu-hours';
import pickupDetails from './components/pickup-details';
import dropoffDetails from './components/drop-off-details';
import salesChannel from './components/sales-channel';
import reporting from './components/reporting';
import kds from './components/kds';
import centricPos from './components/centric-pos';
import financialConfig from './components/financial-config';
import { beforeEnter } from './../guards';
import overview from './components/overview';
import { useSplitIoStore } from '@centric-os/stores/splitio/use-split-io';
import { FeatureFlags } from '@centric-os/types';
import activityLog from './components/activity-log';

const Component = () => import('./SiteDetails.vue');

export default {
  path: buildChildURL(SitesRoutePathNames.SITE),
  name: SitesRouteNames.SITE_DETAILS,
  component: Component,
  redirect: () => {
    const { isFeatureOn } = useSplitIoStore();
    return {
      name: isFeatureOn(FeatureFlags.CENTRIC_HOME_OVERVIEW_SITE) ? overview.name : menuHours.name,
    };
  },
  beforeEnter: beforeEnter,
  children: [
    overview,
    menuHours,
    pickupDetails,
    dropoffDetails,
    salesChannel,
    {
      path: 'device-mapping',
      redirect: { name: SitesRouteNames.SITE_DETAILS },
    },
    reporting,
    kds,
    centricPos,
    financialConfig,
    activityLog,
  ],
} as RouteRecordRaw;
